import ViewGridPageSkeleton from '../ViewGrid/skeletons/ViewGridPageSkeleton';

/** Destination chrome while a viewed grid (or its redirect hop) is loading. */
const GridPageSkeleton = () => <ViewGridPageSkeleton />;

export default GridPageSkeleton;
